module.exports = __webpack_public_path__ + "img/pm.be825203.svg";